// src/data/products.js

// CATEGORY KEYS (used everywhere: filters, routing, home sections)
export const PRODUCT_CATEGORIES = {
  HEELS: "heels",
  SNEAKERS: "sneakers",
  BOOTS: "boots",
  FLATS_LOAFERS: "flats-loafers",
  SANDALS: "sandals",
  ACCESSORIES: "bags",
};

// TAG KEYS
// "new-in", "bestsellers", "sale" will be used by the Home sections
export const PRODUCT_TAGS = {
  NEW_IN: "new-in",
  BESTSELLER: "bestsellers",
  SALE: "sale",
};

// Luxury demo products (replace images with your real ones)
export const PRODUCTS = [
  {
    id: "heels-roma-nude",
    nameEN: "Roma Stiletto Heels – Nude",
    nameAR: "حذاء كعب روما – نيود",
    shortDescEN: "Handcrafted Italian leather stiletto for evening looks.",
    shortDescAR: "كعب إيطالي فاخر من الجلد لمناسبات السهرة.",
    category: PRODUCT_CATEGORIES.HEELS,
    price: 180,
    discount: 0,
    stock: 8,
    images: [
      "/images/products/heels-roma-1.jpg",
      "/images/products/heels-roma-2.jpg",
      "/images/products/heels-roma-3.jpg",
    ],
    colors: [
      { name: "Nude", code: "#E6CFCB" },
      { name: "Black", code: "#000000" },
    ],
    sizes: [
      { size: 36, inStock: true },
      { size: 37, inStock: true },
      { size: 38, inStock: true },
      { size: 39, inStock: true },
      { size: 40, inStock: false },
    ],
    heelHeight: 9,
    tags: [PRODUCT_TAGS.NEW_IN, PRODUCT_TAGS.BESTSELLER],
    descriptionEN:
      "Elegant Roma stilettos handcrafted in Italy from premium smooth leather. Perfect for evening wear and special occasions.",
    descriptionAR:
      "كعب روما أنيق مصنوع يدويًا في إيطاليا من جلد ناعم فاخر. مثالي للسهرة والمناسبات الخاصة.",
    newIndex: 10,
  },

  {
    id: "heels-milano-black",
    nameEN: "Milano Block Heels – Black",
    nameAR: "كعب ميلانو العريض – أسود",
    shortDescEN: "Comfort block heel with Italian sophistication.",
    shortDescAR: "كعب عريض مريح بلمسة فخامة إيطالية.",
    category: PRODUCT_CATEGORIES.HEELS,
    price: 165,
    discount: 15, // 15% off
    stock: 5,
    images: [
      "/images/products/heels-milano-1.jpg",
      "/images/products/heels-milano-2.jpg",
    ],
    colors: [{ name: "Black", code: "#000000" }],
    sizes: [
      { size: 36, inStock: true },
      { size: 37, inStock: false },
      { size: 38, inStock: true },
      { size: 39, inStock: true },
      { size: 40, inStock: true },
    ],
    heelHeight: 7,
    tags: [PRODUCT_TAGS.SALE],
    descriptionEN:
      "Milano block heels combine comfort and elegance with a stable heel and smooth Italian leather.",
    descriptionAR:
      "كعب ميلانو العريض يجمع بين الراحة والأناقة مع كعب ثابت وجلد إيطالي ناعم.",
    newIndex: 8,
  },

  {
    id: "sneakers-venezia-white",
    nameEN: "Venezia Leather Sneakers – White",
    nameAR: "سنيكرز فينيسيا – أبيض",
    shortDescEN: "Minimal Italian sneakers for everyday luxury.",
    shortDescAR: "سنيكرز إيطالي ناعم لإطلالة يومية فاخرة.",
    category: PRODUCT_CATEGORIES.SNEAKERS,
    price: 140,
    discount: 0,
    stock: 15,
    images: [
      "/images/products/sneakers-venezia-1.jpg",
      "/images/products/sneakers-venezia-2.jpg",
    ],
    colors: [
      { name: "White", code: "#F7F7F7" },
      { name: "Beige", code: "#EADCCF" },
    ],
    sizes: [
      { size: 36, inStock: true },
      { size: 37, inStock: true },
      { size: 38, inStock: true },
      { size: 39, inStock: true },
      { size: 40, inStock: true },
      { size: 41, inStock: true },
    ],
    heelHeight: 3,
    tags: [PRODUCT_TAGS.NEW_IN],
    descriptionEN:
      "Clean leather sneakers with subtle Italian detailing. Pairs perfectly with denim and dresses.",
    descriptionAR:
      "سنيكرز من الجلد بتفاصيل إيطالية ناعمة، مثالي مع الجينز أو الفساتين لإطلالة يومية أنيقة.",
    newIndex: 11,
  },

  {
    id: "boots-torino-black",
    nameEN: "Torino High Boots – Black",
    nameAR: "بوت تورينو العالي – أسود",
    shortDescEN: "Knee-high leather boots for winter elegance.",
    shortDescAR: "بوت جلدي طويل أنيق لفصل الشتاء.",
    category: PRODUCT_CATEGORIES.BOOTS,
    price: 220,
    discount: 20,
    stock: 6,
    images: [
      "/images/products/boots-torino-1.jpg",
      "/images/products/boots-torino-2.jpg",
    ],
    colors: [{ name: "Black", code: "#000000" }],
    sizes: [
      { size: 36, inStock: true },
      { size: 37, inStock: true },
      { size: 38, inStock: false },
      { size: 39, inStock: true },
      { size: 40, inStock: true },
    ],
    heelHeight: 6,
    tags: [PRODUCT_TAGS.BESTSELLER, PRODUCT_TAGS.SALE],
    descriptionEN:
      "Elegant knee-high boots with a refined silhouette and soft leather lining.",
    descriptionAR:
      "بوت طويل أنيق بقصة راقية وبطانة داخلية ناعمة من الجلد.",
    newIndex: 9,
  },

  {
    id: "flats-bella-nude",
    nameEN: "Bella Flats – Nude",
    nameAR: "حذاء فلات بيلا – نيود",
    shortDescEN: "Italian flat with soft insole for all-day wear.",
    shortDescAR: "حذاء فلات إيطالي ناعم ومريح للاستخدام اليومي.",
    category: PRODUCT_CATEGORIES.FLATS_LOAFERS,
    price: 115,
    discount: 0,
    stock: 10,
    images: [
      "/images/products/flats-bella-1.jpg",
      "/images/products/flats-bella-2.jpg",
    ],
    colors: [{ name: "Nude", code: "#E6CFCB" }],
    sizes: [
      { size: 36, inStock: true },
      { size: 37, inStock: true },
      { size: 38, inStock: true },
      { size: 39, inStock: true },
      { size: 40, inStock: true },
    ],
    heelHeight: 1,
    tags: [PRODUCT_TAGS.NEW_IN],
    descriptionEN:
      "Minimal flat with a cushioned insole and soft Italian leather finish.",
    descriptionAR:
      "فلات بسيط مع نعل مبطن ولمسة نهائية من الجلد الإيطالي الناعم.",
    newIndex: 7,
  },

  {
    id: "loafers-verona-black",
    nameEN: "Verona Loafers – Black",
    nameAR: "لوفر فيرونا – أسود",
    shortDescEN: "Classic loafer with gold detail.",
    shortDescAR: "حذاء لوفر كلاسيكي بتفاصيل ذهبية ناعمة.",
    category: PRODUCT_CATEGORIES.FLATS_LOAFERS,
    price: 135,
    discount: 10,
    stock: 9,
    images: [
      "/images/products/loafers-verona-1.jpg",
      "/images/products/loafers-verona-2.jpg",
    ],
    colors: [{ name: "Black", code: "#000000" }],
    sizes: [
      { size: 36, inStock: true },
      { size: 37, inStock: false },
      { size: 38, inStock: true },
      { size: 39, inStock: true },
      { size: 40, inStock: true },
    ],
    heelHeight: 2,
    tags: [PRODUCT_TAGS.SALE],
    descriptionEN:
      "Classic black loafers with gold hardware and polished finish.",
    descriptionAR:
      "لوفر أسود كلاسيكي مع قطعة معدنية ذهبية ولمسة نهائية لامعة.",
    newIndex: 5,
  },

  {
    id: "sandals-amalfi-gold",
    nameEN: "Amalfi Strap Sandals – Gold",
    nameAR: "صندل أمالفي بشرائط – ذهبي",
    shortDescEN: "Delicate strap sandals for summer evenings.",
    shortDescAR: "صندل بشرائط ناعمة لمناسبات الصيف المسائية.",
    category: PRODUCT_CATEGORIES.SANDALS,
    price: 150,
    discount: 0,
    stock: 12,
    images: [
      "/images/products/sandals-amalfi-1.jpg",
      "/images/products/sandals-amalfi-2.jpg",
    ],
    colors: [{ name: "Gold", code: "#D4AF37" }],
    sizes: [
      { size: 36, inStock: true },
      { size: 37, inStock: true },
      { size: 38, inStock: true },
      { size: 39, inStock: true },
    ],
    heelHeight: 5,
    tags: [PRODUCT_TAGS.NEW_IN],
    descriptionEN:
      "Fine gold straps with a soft footbed for elegant summer outfits.",
    descriptionAR:
      "شرائط ذهبية ناعمة مع نعل مريح لإطلالات صيفية أنيقة.",
    newIndex: 6,
  },

  {
    id: "bag-roma-tote",
    nameEN: "Roma Leather Tote Bag – Camel",
    nameAR: "حقيبة روما جلد – كاميل",
    shortDescEN: "Spacious everyday tote in Italian leather.",
    shortDescAR: "حقيبة جلد عملية وواسعة للاستخدام اليومي.",
    category: PRODUCT_CATEGORIES.ACCESSORIES,
    price: 210,
    discount: 0,
    stock: 7,
    images: [
      "/images/products/bag-roma-1.jpg",
      "/images/products/bag-roma-2.jpg",
    ],
    colors: [{ name: "Camel", code: "#C08A4E" }],
    sizes: [],
    heelHeight: null,
    tags: [PRODUCT_TAGS.BESTSELLER],
    descriptionEN:
      "Structured leather tote bag with internal pockets and soft handles.",
    descriptionAR:
      "حقيبة توت structured من الجلد مع جيوب داخلية ومقابض مريحة.",
    newIndex: 4,
  },
];

// Helper: get product by id
export function getProductById(id) {
  return PRODUCTS.find((p) => p.id === id);
}
